const AppConfig = {
  key: {
    LoggedIn: 'loggedInSupportMetaBetALl',
    GlobalMarketKey: 'SelectedGlobalMarketMetaBetALl'
  }
}

export default AppConfig;
